const addWheelAnimation = (explorer, elementId) => {
  let elementToMove;
  const circularMenu = document.getElementById(elementId);
  const liElements = circularMenu.querySelectorAll('li');
  circularMenu.style.overflow = 'visible';
  liElements.forEach((element, i) => {
    const explorerName = element.querySelector('div').attributes.explorer.nodeValue;
    const explorerElementToMove = element.querySelector(`#${explorerName}`);
    if (!elementToMove) {
      elementToMove = explorerElementToMove;
    }
    element.className = element.className + ` fadeOutAnimation`;
    explorerElementToMove.className = explorerElementToMove.className + ` ${explorerName}Animation`;
    element.style.overflow = 'visible';
  });

  const center = document.getElementById('center');
  const canvas = document.getElementsByTagName('canvas')[0];

  center.remove();
  canvas.style.visibility = 'hidden';

  elementToMove &&
    elementToMove.addEventListener('animationend', async () => {
      await explorer.activateExplorer();
      canvas.style.visibility = 'visible';
    });
};

export const wheelAnimation = {
  addWheelAnimation,
};
